import { render, staticRenderFns } from "./TestTab.vue?vue&type=template&id=bd58eb6a&scoped=true&"
import script from "./TestTab.vue?vue&type=script&lang=js&"
export * from "./TestTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd58eb6a",
  null
  
)

export default component.exports